import React from 'react';
import { connect } from 'react-redux';
import './styles.css';

function NroVta({ codpmpol }) {
    return (
        <div className='bottom-container'>
            <div className="nro-container nro-shadow">
                Presupuesto {codpmpol}
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    return {
        codpmpol: state.mainReducer.codpmpol,
    }
};

export default connect(mapStateToProps)(NroVta);
